module.exports = {"ANIMATION_TIME":500,"animationTransition":"all 500ms ease-out"}